module.exports = __webpack_public_path__ + "img/OlderDashboard.9195b993.png";